const generalQuestions = [
	{
		title: `What are your prices based on?`,
		text: `Our prices reflect our quality. We create bespoke website designs with no compromises on functionality. Every project is planned, developed, and tested with our specialists' utmost care and attention to detail. We value quality and customer satisfaction, above all, and this directly influences the prices we set for our work.`,
	},
	{
		title: `What kind of businesses do you work with?`,
		text: `While we have collaborated with businesses across various industries over the years, our work portfolio focuses mainly on eCommerce & tech companies, of which fashion, luxury jewellery, groceries, food & drink and sports businesses are most common.`,
	},
	{
		title: `What development & project management tools do you use?`,
		text: `We use Asana for task management, Slack/Email/Skype/WhatsApp for comms, VSCode for code editing, all Google Workspace & Dev services, Google Meet/Slack/Zoom for meetings, Photoshop & Figma for design and a few other tools that make our life easier and processes faster.`,
	},
	{
		title: `Can you help me update my existing website even if another company built it?`,
		text: `Yes. We encourage you to schedule a call with us to discuss your website's current status and your specific requirements for this update.`,
	},
	{
		title: `Can you build a Shopify theme from scratch?`,
		text: `Of course. If you have a design we will code it into Shopify using Dawn as starter kit. If you need a design too, our team will create one for you, ready-made for Shopify implementation.`,
	},
	{
		title: `Do you offer consulting services?`,
		text: `Yes. We can help you create your development architecture in advance and guide you to find out your project's initial estimations.`,
	},
	{
		title: `Do you provide monthly maintenance services?`,
		text: `Yes. We can create a customised retainer focused on your needs or you can book a monthly number of development hours/days on a yearly plan.`,
	},
];

export default generalQuestions;
